<template>
  <!-- 抽奖组件主容器 -->
  <div class="lottery-container">
    <!-- 头部标题区域 -->
    <div class="lottery-header">
      <h1 class="lottery-title">幸运抽奖</h1>
      <p class="lottery-subtitle">恭喜您获得一次抽奖机会！</p>
    </div>

    <!-- 主要内容区域 -->
    <div class="lottery-content">
      <!-- 抽奖转盘容器 -->
      <div class="lottery-wrapper" :style="wheelWrapperStyle">
        <!-- 指针指示器 -->
        <div class="pointer"></div>

        <!-- 抽奖转盘主体 -->
        <div class="lottery-wheel" :class="{ 'spinning': isSpinning }" :style="wheelStyle">
          <!-- 直接在wheelStyle中设置彩色轮盘背景 -->

          <!-- 单独渲染奖品文字，确保它们不受clipPath影响 -->
          <div
              class="prize-text"
              v-for="(prize, index) in prizes"
              :key="'prize-text-' + index"

              :style="getTextPositionStyle(index)"
          >
            <div class="prize-content">
<!--              <img class="prize-item-icon" :src="prize.img" alt="奖品图标">-->
              <span>{{ prize.name }}</span>
            </div>
          </div>
        </div>

        <!-- 转盘中心按钮 -->
        <div class="wheel-center">
          <div
              class="center-circle"
              :class="{ disabled: isSpinning || remainingDraws <= 0 || act_Status===false}"
          >
            {{ remainingDraws > 0 ? '开始抽奖' : '次数用尽' }}
          </div>
        </div>
      </div>

      <!-- 抽奖信息和操作区域 -->
      <div class="lottery-info">
        <div class="draw-count">
          <span class="count-label">剩余抽奖次数：</span>
          <span class="count-number">{{ remainingDraws }}</span>
        </div>

        <button
            class="draw-button"
            @click="startDraw"
            :disabled="isSpinning || remainingDraws <= 0 || act_Status===false"
        >
          <span v-if="!isSpinning && remainingDraws > 0 && act_Status">开始抽奖</span>
          <span v-else-if="isSpinning">抽奖中...</span>
          <span v-else>{{ drawButtonDisabledText }}</span>
        </button>

        <!-- 测试用按钮组 -->
        <!-- <div class="test-controls">
          <div class="test-title">测试功能</div>
          <div class="test-buttons">
            <button v-for="(prize, index) in prizes" :key="prize.id + '-test'"
                    class="test-btn" @click="testRotation(index)">
              测试 {{ prize.name }}
            </button>
          </div>
        </div> -->

        <div class="prize-preview">
          <h3>🎁 奖品预览</h3>
          <div class="prize-list">
            <div class="prize-item" v-for="(prize, index) in prizes" :key="index">
              <img class="prize-item-icon" :src="prize.img" alt="奖品图标">
              <span class="prize-item-name">{{ prize.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 抽奖结果弹窗 -->
    <div class="result-modal" v-if="showResult">
      <div class="modal-content">
        <div class="result-icon">
          <img class="prize-item-icon" :src="resultImg" alt="奖品图标">
        </div>
        <h2 class="result-title">{{ resultText }}</h2>
        <p class="result-prize">{{ resultName }}</p>
        <button class="result-button" @click="handleResult">
          {{ resultButtonText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// 导入抽奖相关的API方法
import {lotteryAPI} from '../utils/api';
import globalStore from '../utils/globalStore.js';

export default {
  name: 'Lottery',

  data() {
    return {
      globalStore,
      isSpinning: false, // 转盘是否正在旋转
      rotation: 0, // 转盘当前的旋转角度
      animationDuration: 5000, // 5秒动画时长
      remainingDraws: 0, // 模拟剩余抽奖次数
      act_Status: true, //活动状态
      act_Status_Msg: '活动已结束',//活动信息
      showResult: false, // 是否显示抽奖结果弹窗
      resultPrize: null, // 抽奖结果
      code: null, // 抽奖结果中奖码
      resultText: '', // 结果提示文本
      resultImg: require('../images/4001.png'),//结果图标
      resultCode: 0,
      resultName: '',//结果名称
      resultButtonText: '', // 结果按钮文本
      prizes: [ // 模拟奖品数据
        {id: 1, name: '一等奖', icon: '🏆'},
        {id: 2, name: '二等奖', icon: '🎁'},
        {id: 3, name: '三等奖', icon: '🎉'},
        {id: 4, name: '四等奖', icon: '🎈'},
        {id: 5, name: '参与奖', icon: '🌟'},
        {id: 6, name: '谢谢参与', icon: '😊'}
      ],
      actId: null,
      viewportWidth: window.innerWidth, // 当前视口宽度
      sectionStyles: [], // 扇区样式数组，直接存储计算结果
      stylesCalculated: false, // 标记样式是否已计算，确保只计算一次
      svgPath: '', // SVG路径字符串，用于渲染彩色扇区
      testPrizeIndex: undefined, // 测试用奖品索引，设置后可固定抽奖结果，undefined表示随机
      isDevMode: false // 开发模式标志，控制是否显示测试功能
    }
  },

  computed: {
    // 计算转盘容器的尺寸样式
    wheelWrapperStyle() {
      const isMobile = this.viewportWidth < 768;
      const size = isMobile ? '70vw' : '400px';

      return {
        width: size,
        height: size
      };
    },
    // 根据后端返回的状态动态计算抽奖按钮禁用时的文本
    drawButtonDisabledText() {
      // 根据remainingDraws的值返回不同的文本

      //   return '抽奖机会已用完';
      // } else {
      if (this.remainingDraws <= 0) {
        return '抽奖次数已用完';
      } else {
        if (!this.act_Status) {
          console.log("活动状态:", this.act_Status, "活动信息:", this.act_Status_Msg);
          return this.act_Status_Msg;
        } else {
          return '活动暂未开始';
        }

      }
    },
    // 计算转盘的样式
    wheelStyle() {
      // 为每个奖品分配固定颜色，与prizes数组直接对应
      const totalPrizes = this.prizes.length;
      const anglePerSection = 360 / totalPrizes;
      let gradientStops = [];


      // 为每个奖品分配固定颜色
      // 根据奖品重要性排序：一等奖-红色，二等奖-蓝色，三等奖-黄色，依此类推
      const prizeColors = ['#448AFF', '#FF5252', '#FFC107', '#4CAF50', '#9C27B0', '#FF9800'];

      // 生成精确的渐变停止点，确保颜色与奖品位置完全对应
      // 考虑到文本是放在扇区中间，我们需要确保颜色扇区与文本位置精确对齐
      // 通过观察DOM，我们发现指针指向的位置与颜色扇区有偏移，需要特殊调整
      for (let i = 0; i < totalPrizes; i++) {
        // 关键点：为了确保颜色扇区与奖品文本完全对应，我们需要调整起始角度
        // 观察到当前的文本位置和指针指向关系，我们需要将颜色扇区整体旋转一个偏移量
        // 这个偏移量应该是扇区角度的一半，以确保颜色扇区的边界与文本位置对齐
        const startAngle = i * anglePerSection;
        const endAngle = startAngle + anglePerSection;

        // 使用与当前奖品索引对应的固定颜色
        gradientStops.push(`${prizeColors[i % prizeColors.length]} ${startAngle}deg ${endAngle}deg`);
      }

      // 组合成conic-gradient
      const conicGradient = `conic-gradient(from -${anglePerSection / 2}deg, ${gradientStops.join(', ')})`;

      return {
        transform: `rotate(${this.rotation}deg)`,
        width: '100%',
        height: '100%',
        background: conicGradient,
        // 添加白色边框分隔扇区
        backgroundSize: 'calc(100% - 2px) calc(100% - 2px)',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      };
    }
  },

  methods: {
    // 获取抽奖信息
    async fetchLotteryInfo() {
      try {
        // 尝试调用API，失败时使用模拟数据
        const response = await lotteryAPI.getLotteryInfo(globalStore.getUrlParams());
        if (response.code == 0) {
          console.log("抽奖信息剩余次数:", response.data.remainingDraws);
          this.remainingDraws = response.data.remainingDraws;
          if (response.data.act_Status != null) {
            this.act_Status = response.data.act_Status;
            this.act_Status_Msg = response.data.act_Status_Msg;
          }
          this.prizes = response.data.prizes;
          this.actId = response.data.actId;
        }
      } catch (error) {
        console.log('使用模拟数据');
        // 使用已经设置的模拟数据
      } finally {
        // 无论是否成功获取API数据，都计算扇区样式
        this.calculateSectionStyles();
      }
    },


    calculateSectionStyles() {
      // 确保样式只计算一次
      if (this.stylesCalculated || this.prizes.length === 0) {
        return;
      }
      // 这个方法现在只是标记样式已计算
      // 实际的扇区渲染由SVG和getSectorPath/getSectorColor方法处理
      this.stylesCalculated = true;
    },

    // 计算奖品文字的位置样式
    getTextPositionStyle(index) {
      const totalPrizes = this.prizes.length;
      const anglePerSection = 360 / totalPrizes;
      const middleAngle = index * anglePerSection + anglePerSection / 2;

      // 将角度转换为弧度
      const angleRad = middleAngle * Math.PI / 180;

      // 计算距离中心的位置 (30% 是从中心到文字的距离)
      const radius = 30;
      const x = 50 + radius * Math.cos(angleRad);
      const y = 50 - radius * Math.sin(angleRad); // Y轴向下为正，所以减号

    //  const textRotation = middleAngle;
   const textRotation = 0;
      return {
        position: 'absolute',
        left: `${x}%`,
        top: `${y}%`,
        transformOrigin: 'center',
        transform: `translate(-50%, -50%) rotate(${textRotation}deg)`,
        zIndex: 1000,
        pointerEvents: 'none', // 确保不影响点击
        width: '40%', // 足够的宽度来容纳文字
        textAlign: 'center'
      };
    },

    // 处理窗口大小变化
    handleResize() {
      this.viewportWidth = window.innerWidth;
    },


    // 执行抽奖动画
    drawAnimation(prizeIndex) {
      // 计算扇区角度
      const sectorAngle = 360 / this.prizes.length;

      // 计算随机旋转圈数，使动画效果更自然
      const randomSpins = 5 + Math.floor(Math.random() * 5); // 5-9圈随机旋转

      // 关键修复：使用索引偏移确保指针指向正确的奖品
      // 经过分析，需要将原始索引加1以匹配颜色扇区
      // const adjustedPrizeIndex = prizeIndex + 1;

      // // 计算目标色块的精确中心位置
      // const targetSectorCenter = adjustedPrizeIndex * sectorAngle + sectorAngle / 2;

      // // 计算最终旋转角度
      // const targetBaseAngle = -(-90 + targetSectorCenter);


      // 精确的旋转计算逻辑 - 使用直接映射
      // 根据用户反馈，只有二等奖和幸运奖(参与奖)能正常显示
      // 现在我们使用一个精确的映射表，确保每个奖品都能正确指向

      // 创建一个精确的映射表，将奖品索引直接映射到正确的旋转角度
      // 经过测试，我们发现：
      const angleMap = [
        -60,   // 一等奖 (索引0)
        0,     // 二等奖 (索引1) - 已知能正常显示
        60,    // 三等奖 (索引2)
        120,   // 四等奖 (索引3)
        180,   // 参与奖/幸运奖 (索引4) - 已知能正常显示
        240    // 谢谢参与 (索引5)
      ];

      // 获取当前奖品对应的精确旋转角度
      const targetBaseAngle = angleMap[prizeIndex];


      const targetRotation = targetBaseAngle + 360 * randomSpins;

      // 输出调试信息
      console.log(`扇区角度: ${sectorAngle}°`);
      console.log(`当前旋转角度: ${this.rotation}°`);
      console.log(`目标奖品: ${this.resultName} (索引: ${prizeIndex})`);
      console.log(`角度映射: 通过映射表获取角度 ${targetBaseAngle}°`);
      console.log(`随机旋转圈数: ${randomSpins} (${randomSpins * 360}°)`);
      console.log(`最终旋转目标角度: ${targetRotation}°`);
      console.log(`预期结果: 指针将准确指向 ${this.resultName}`);
      console.log(`=== 计算完成 ===`);
      //   console.log(`=== 抽奖动画开始 ===`);
      //    console.log(`扇区角度: ${sectorAngle}°`);
      //   console.log(`原始奖品索引: ${prizeIndex}`);
      //  // console.log(`调整后索引: ${adjustedPrizeIndex}`);
      // //  console.log(`目标色块中心: ${targetSectorCenter}°`);
      //   console.log(`基础旋转角度: ${targetBaseAngle}°`);
      //   console.log(`旋转圈数: ${randomSpins} (${randomSpins * 360}°)`);
      //   console.log(`最终旋转角度: ${targetRotation}°`);
      //   console.log(`==================`);

      // 立即执行旋转动画
      this.rotation = targetRotation;
    },

    // 开始抽奖
    async startDraw() {
      // 防重复点击校验
      if (this.isSpinning || this.remainingDraws <= 0 || this.prizes.length === 0) return;
      // 更新状态
      this.isSpinning = true;
      this.remainingDraws--;
      // 模拟抽奖过程 - 使用同步方式，确保移动设备兼容性
      // 注意：这里可以取消注释特定行来测试固定奖品
      // 例如，测试一等奖时取消下面这行的注释
      // const prizeIndex = 0; // 一等奖
      // const prizeIndex = 1; // 二等奖
      // const prizeIndex = 2; // 三等奖
      // const prizeIndex = 3; // 四等奖
      // const prizeIndex = 4; // 参与奖
      // const prizeIndex = 5; // 谢谢参与

      // 调用API获取抽奖结果
      try {
        // 从全局存储获取用户openid等必要参数
        const params = {
          ...globalStore.getUrlParams(),
          actId: this.actId
        };
        // 调用抽奖API
        const response = await lotteryAPI.startDraw(params);
        console.log("抽中了啥", response.data)
        this.resultCode = response.code;
        // 检查响应
        if (!response || !response.code == 0 || !response.data) {
          if (response.code === 4001) {
            this.showResult = true;
            this.resultButtonText = response.msg;
            this.isSpinning = false;
            return;
          }
          throw new Error('抽奖结果数据格式错误');
        }
        if (response.data.isReward == 1) {
          // 获取后端返回的抽中奖品
          const drawnPrize = response.data;
          this.resultPrize = drawnPrize;
          console.log("抽中的奖品", drawnPrize)
          console.log("奖品列表", this.prizes)
          // 在本地奖品列表中查找对应索引
          // 注意：这里需要确保后端返回的奖品与本地奖品列表匹配
          const prizeIndex = this.prizes.findIndex(prize => prize.name === drawnPrize.name);
          console.log("抽中的奖品下标：", prizeIndex)
          // 如果找不到匹配的奖品，使用默认值（如最后一个奖品）
          if (prizeIndex === -1) {
            console.warn('未找到匹配的奖品，使用默认奖品');
            return this.handleDrawEnd(this.prizes[this.prizes.length - 1], false);
          }

          // 记录是否为高价值奖品
          const isHighPrize = response.data.c_type === '一等奖' || false;
          // 执行抽奖动画并显示结果
          this.drawAnimation(prizeIndex);

          if (prizeIndex === 5) {
            setTimeout(() => {
              this.showResult = true;
              this.resultText = '很遗憾，没有中奖。';
              this.resultImg = this.prizes[5].img || '#';
              this.resultButtonText = '阅读公众号文章有机会获取抽奖机会';
              this.isSpinning = false;
            }, this.animationDuration);
            return;
          } else {
            // 抽奖动画完成后处理结果
            setTimeout(() => {
              this.handleDrawEnd(drawnPrize, isHighPrize);
            }, this.animationDuration);
            return;
          }
        } else {
          // 显示错误信息并允许用户重试
          // 执行抽奖动画并显示结果
          const prizeIndex = this.prizes.findIndex(prize => prize.awardsName === '谢谢参与');
          console.log("谢谢参与的下标", prizeIndex)
          this.drawAnimation(prizeIndex);
          setTimeout(() => {
            this.showResult = true;
            this.resultImg = this.prizes[5].img || '#';
            this.resultText = '很遗憾，没有中奖。';
            this.resultButtonText = '阅读公众号文章有机会获取抽奖机会';
            this.isSpinning = false;
            return;
          }, this.animationDuration);

        }

      } catch (error) {
        console.log("抽奖失败")
        // if(error.response.code===4001){
        //   this.showResult = true;
        // this.resultImg = this.prizes[5].img || '#';
        // this.resultText = error.response.msg || '很遗憾，没有中奖。';
        // this.resultButtonText = '阅读公众号文章有机会获取抽奖机会';
        // this.isSpinning = false;
        // return;
        // }
        // 显示错误信息并允许用户重试
        this.showResult = true;
        this.resultText = '抽奖失败，请稍后重试';
        this.resultButtonText = '重试';
        this.resultCode = 500;
        this.isSpinning = false;
        return;
      }
    },

    // 处理抽奖结束逻辑
    handleDrawEnd(prize, isHighPrize) {
      // 更新状态
      this.isSpinning = false;

      // 设置结果信息
      this.resultPrize = prize;
      this.resultName = prize.name;
      this.resultText = isHighPrize ? '恭喜您中奖了！' : prize.name;
      this.resultButtonText = prize.title || (isHighPrize ? '领取奖品' : '继续参与');
      this.resultImg = prize.img || '#';
      this.code = prize.code;
      // 显示结果弹窗
      this.showResult = true;
    },

    // 处理抽奖结果按钮点击
    handleResult() {
      // 隐藏结果弹窗
      this.showResult = false;

      // 根据获奖等级跳转到不同页面
      if (this.resultName !== '') {
        console.log("code", this.code);
        this.$router.push({path: '/prize', query: {code: this.code}});
      } else if (this.resultCode === 4001) {
        return;
      } else {
        this.$router.push('/failure');
      }
    }
  },

  mounted() {
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
    // 初始化时获取抽奖信息，内部会处理样式计算
    this.fetchLotteryInfo();
  },

  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener('resize', this.handleResize);
  }
}
</script>

<style scoped>
/* 抽奖页面主容器样式 */
.lottery-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  background: -webkit-linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  position: relative;
  overflow: hidden;
}

/* 头部区域样式 */
.lottery-header {
  text-align: center;
  margin-bottom: 40px;
  position: relative;
  z-index: 1;
}

.lottery-title {
  font-size: 2.8rem;
  color: white;
  margin-bottom: 10px;
  font-weight: 800;
  text-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}

.lottery-subtitle {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 300;
}

/* 主要内容区域 */
.lottery-content {
  max-width: 1000px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  position: relative;
  z-index: 1;
}

/* 抽奖转盘容器 */
.lottery-wrapper {
  position: relative;
  width: 100%;
  margin: 0 auto;
}

/* 抽奖转盘主体 */
.lottery-wheel {
  width: 100%;
  height: 100%;
  /* background: white; */
  border-radius: 50%;
  position: relative;
  overflow: hidden;
  /* border: 8px solid #ffffff; */
  /* 旋转动画 - 确保所有浏览器兼容性 */
  transition: transform 5s cubic-bezier(0.25, 0.1, 0.25, 1);
  -webkit-transition: transform 5s cubic-bezier(0.25, 0.1, 0.25, 1);
  -moz-transition: transform 5s cubic-bezier(0.25, 0.1, 0.25, 1);
  -o-transition: transform 5s cubic-bezier(0.25, 0.1, 0.25, 1);
  /* GPU加速 */
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  -moz-transform: translateZ(0);
  -o-transform: translateZ(0);
}

/* 奖品文字容器样式 */
.prize-text {
  overflow: visible !important;
}

/* 奖品内容样式 */
.prize-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  overflow: visible;
}

/* 奖品文字样式 */
.prize-content span {
  display: block;
  font-weight: 900 !important;
  color: white !important;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(0, 0, 0, 0.5);
  white-space: nowrap;
  overflow: visible;
  position: relative;
  z-index: 2000;
}

/* 图标样式 */
.prize-content span:first-child {
  font-size: 32px;
  margin-bottom: 6px;
}

/* 奖品名称样式 */
.prize-content span:last-child {
  font-size: 16px;
  font-weight: bold;
  line-height: 1.2;
}

/* 转盘上的奖品图标 */
.prize-content .prize-item-icon {
  width: 30px;
  height: 30px;
  object-fit: contain;
  margin-bottom: 5px;
}

/* 奖品预览区的图标 */
.prize-list .prize-item-icon {
  width: 40px;
  height: 40px;
  object-fit: contain;
  margin-bottom: 5px;
}

/* 结果弹窗中的图标 */
.result-icon .prize-item-icon {
  width: 80px;
  height: 80px;
  object-fit: contain;
}

/* 指针指示器样式 */
.pointer {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-bottom: 25px solid #ff6b6b;
  z-index: 10;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

/* 指针底部固定效果 */
.pointer::after {
  content: '';
  position: absolute;
  bottom: -25px;
  left: -5px;
  width: 10px;
  height: 5px;
  background-color: #ff6b6b;
  border-radius: 0 0 50% 50%;
}

/* 转盘中心样式 */
.wheel-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 20%;
  height: 20%;
  border-radius: 50%;
  background: linear-gradient(135deg, #ff6b6b, #ee5a24);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 中心圆形按钮样式 */
.center-circle {
  width: 80%;
  height: 80%;
  border-radius: 50%;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ff6b6b;
  font-weight: bold;
  cursor: pointer;
  user-select: none;
  transition: all 0.3s ease;
  box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.1);
  font-size: 0.9rem;
  text-align: center;
  padding: 5px;
}

/* 中心按钮点击效果 */
.center-circle:active:not(.disabled) {
  transform: scale(0.95);
  box-shadow: inset 0 4px 8px rgba(0, 0, 0, 0.2);
}

/* 禁用状态样式 */
.center-circle.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background-color: #f0f0f0;
  color: #999;
}

/* 响应式设计 - 移动设备 */
@media (max-width: 768px) {
  .prize-icon {
    font-size: 0.9rem !important;
  }

  .prize-name {
    font-size: 0.6rem !important;
    line-height: 1.1;
  }

  .lottery-title {
    font-size: 2rem;
  }

  .lottery-subtitle {
    font-size: 1rem;
  }

  /* 移动设备上的图标尺寸调整 */
  .prize-content .prize-item-icon {
    width: 24px;
    height: 24px;
  }

  .prize-list .prize-item-icon {
    width: 32px;
    height: 32px;
  }

  .result-icon .prize-item-icon {
    width: 60px;
    height: 60px;
  }
}

/* 抽奖信息区域 */
.lottery-info {
  text-align: center;
  color: white;
  width: 100%;
  max-width: 400px;
}

.draw-count {
  margin-bottom: 20px;
  font-size: 1.2rem;
}

.count-number {
  font-size: 1.5rem;
  font-weight: bold;
  color: #ffd700;
}

.draw-button {
  background: linear-gradient(135deg, #ff6b6b, #ee5a24);
  color: white;
  border: none;
  padding: 15px 40px;
  border-radius: 30px;
  font-size: 1.2rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 30px;
  width: 100%;
  max-width: 300px;
}

.draw-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(255, 107, 107, 0.4);
}

.draw-button:disabled {
  background: #cccccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* 测试控制区域 */
.test-controls {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  padding: 15px;
  margin-bottom: 20px;
  backdrop-filter: blur(10px);
}

.test-title {
  margin-bottom: 10px;
  font-size: 1.1rem;
  font-weight: bold;
}

.test-buttons {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: 8px;
}

.test-btn {
  padding: 8px;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 5px;
  color: white;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.test-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
}

/* 奖品预览区域 */
.prize-preview {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  padding: 20px;
  backdrop-filter: blur(10px);
}

.prize-preview h3 {
  margin-bottom: 15px;
  font-size: 1.3rem;
}

.prize-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.prize-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  transition: transform 0.2s ease;
}

.prize-item:hover {
  transform: scale(1.05);
}

.prize-item-icon {
  font-size: 1.5rem;
  margin-bottom: 5px;
}

.prize-item-name {
  font-size: 0.8rem;
}

/* 结果弹窗样式 */
.result-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}

.modal-content {
  background: white;
  border-radius: 20px;
  padding: 40px;
  text-align: center;
  max-width: 90%;
  width: 400px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  animation: modalAppear 0.3s ease;
}

@keyframes modalAppear {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.result-icon {
  font-size: 4rem;
  margin-bottom: 20px;
}

.result-title {
  font-size: 1.8rem;
  color: #333;
  margin-bottom: 10px;
}

.result-prize {
  font-size: 1.4rem;
  color: #ff6b6b;
  font-weight: bold;
  margin-bottom: 30px;
}

.result-button {
  background: linear-gradient(135deg, #ff6b6b, #ee5a24);
  color: white;
  border: none;
  padding: 15px 30px;
  border-radius: 30px;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
}

.result-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(255, 107, 107, 0.4);
}
</style>
